import Axios from "axios";
import ApiUtils from "../utils/api_utils";

const API_URL = `https://${ApiUtils.authority}`;

export const getFeeds = (page, token) => {
  return Axios.get(`${API_URL}/feeds/api/list/?page=${page}`, {
    headers: ApiUtils.getHeader({ token }),
    withCredentials: false,
  });
};
